import React from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useLocation, useParams } from 'react-router' 
import ViewAppointmentDetails from '../../containers/appointments/ViewAppointmentDetails';
import CalendlyProvider from "../../store/appointments/appointmentsProvider";

function AppointmentDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';

  return (
    <CalendlyProvider>
      <PageWrapper navbar title={'Appointment Details'}>
        {id && <ViewAppointmentDetails appointmentId={id} appointment={location?.state?.appointment}/>}
      </PageWrapper>
      </CalendlyProvider>
  )
}

export default AppointmentDetails;